import styled from 'styled-components';

/** Container único do formulário do step (endereço + blocos seguintes). Espaçamento padrão entre blocos. */
export const StepFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

/** Separador visual entre blocos do formulário (endereço | data/instruções | responsável). */
export const FormBlockSeparator = styled.div`
    margin-top: 28px;
    margin-bottom: 20px;
    padding-top: 24px;
    border-top: 1px solid ${({ theme }) => theme?.colors?.gray?.[200] || '#e5e7eb'};
    &:first-of-type {
        margin-top: 24px;
        padding-top: 24px;
    }
`;

/** Título do bloco dentro do formulário (ex.: "Data e instruções de coleta"). */
export const FormBlockTitle = styled.span`
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme?.colors?.gray?.[700] || '#374151'};
    margin-bottom: 16px;
    letter-spacing: 0.01em;
`;

export const DateTimeRow = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    & > div {
        flex: 1 1 140px;
        min-width: 0;
    }
    input[type="date"],
    input[type="time"] {
        padding: 8px 12px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        font-size: 14px;
        font-family: inherit;
        color: ${({ theme }) => theme?.colors?.gray?.[800] || '#1f2937'};
        width: 100%;
    }
`;

export const TextAreaStyle = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    font: 'inherit',
    fontSize: '14px',
    resize: 'vertical',
    backgroundColor: '#fff',
};

export function splitDateTime(dateTimeStr) {
    if (!dateTimeStr || typeof dateTimeStr !== 'string') return { date: '', time: '' };
    const trimmed = dateTimeStr.trim();
    if (trimmed.length >= 16 && trimmed[10] === 'T') {
        return { date: trimmed.slice(0, 10), time: trimmed.slice(11, 16) };
    }
    if (trimmed.length >= 10) return { date: trimmed.slice(0, 10), time: '' };
    return { date: trimmed, time: '' };
}

/**
 * Combina data (YYYY-MM-DD) e hora (HH:mm ou HH:mm:ss) em string ISO-8601
 * compatível com java.time.LocalDateTime: "yyyy-MM-dd'T'HH:mm:ss".
 * Se só a data for informada, retorna "yyyy-MM-dd'T'00:00:00".
 */
export function combineDateTime(date, time) {
    const d = (date || '').trim();
    const t = (time || '').trim();
    if (!d) return '';
    if (!t) return `${d}T00:00:00`;
    const timePart = t.length >= 8 ? t.slice(0, 8) : t.length === 5 ? `${t}:00` : `${t.padEnd(5, '0').slice(0, 5)}:00`;
    return `${d}T${timePart}`;
}
